import { useCallback, useEffect, useState, type RefObject } from 'react';

interface UseIndicatorPositionProps {
  index: number;
  ref: RefObject<HTMLElement>;
}

interface UseIndicatorPositionResult {
  shift: number;
  scale: number;
  ready: boolean;
}

const EMPTY: UseIndicatorPositionResult = {
  shift: 0,
  scale: 0,
  ready: false,
};

export const useIndicatorPosition = (props: UseIndicatorPositionProps): UseIndicatorPositionResult => {
  const [result, setResult] = useState(EMPTY);
  const realign = useCallback(
    (index: number) => {
      if (!props.ref.current) return;
      const items = props.ref.current.querySelectorAll('li');
      if (!items[index]) return;
      const parent = props.ref.current.getBoundingClientRect();
      const rect = items[index].getBoundingClientRect();
      //
      const shift = rect.left - parent.left;
      const scale = rect.width / parent.width;
      setResult({
        shift,
        scale,
        ready: true,
      });
    },
    [props.ref],
  );
  useEffect(() => {
    realign(props.index);
  }, [props.index, realign]);
  return result;
};
